import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WidgetCreditsService {
  private baseUrl = environment.BASE_LA;

  constructor(private http: HttpClient) {}

  getCredits(personId: string, token: string, products?: string): Promise<any> {
    let params = new HttpParams().set('token', token);
    if (products) params = params.set('products', products);
    const headers = { 'X-Skip-Auth-Interceptor': 'true' };

    return lastValueFrom(
      this.http.get<any>(
        `${this.baseUrl}/api/widget/credits/person/${personId}`,
        { params, headers }
      )
    );
  }

  getInstallments(personId: string, invoiceCode: string, token: string): Promise<any> {
    const params = new HttpParams().set('token', token);
    const headers = { 'X-Skip-Auth-Interceptor': 'true' };

    return lastValueFrom(
      this.http.get<any>(
        `${this.baseUrl}/api/widget/credits/${personId}/installments/${invoiceCode}`,
        { params, headers }
      )
    );
  }

  getInstallmentPayments(personId: string, installmentCode: string, token: string): Promise<any> {
    const params = new HttpParams().set('token', token);
    const headers = { 'X-Skip-Auth-Interceptor': 'true' };

    return lastValueFrom(
      this.http.get<any>(
        `${this.baseUrl}/api/widget/credits/${personId}/installment-payments/${installmentCode}`,
        { params, headers }
      )
    );
  }
}
